import React, { useEffect, useState } from 'react';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

function ToastMessage({ show, setShow, title, message, onClose, styles, width = 370, position }) {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile screen width
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust 768px as needed for mobile breakpoint
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Run on mount to set initial value

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (show) {
      setIsVisible(true);
    }
  }, [show]);

  const toggleShow = () => {
    setShow(false);
    if (onClose) onClose();
  };

  return (
    !isMobile && isVisible && (
      <div
        aria-live="polite"
        aria-atomic="true"
        className={`toast-container ${show ? '' : 'hide'} d-none d-md-block`}
        style={{
          zIndex: 997,
          ...styles,
        }} 
      >
        <ToastContainer position={position?position:'top-end'}>
          <Toast onClose={toggleShow} show={show} animation={false} style={{width}}>
            <Toast.Header>
              <p className="me-auto ff-gothic-bold m-0 p-0">{title}</p>
            </Toast.Header>
            <Toast.Body className="bg-light">{message}</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    )
  );
}

export default ToastMessage;
